import { useMemo } from 'react';
import {
    getImages,
    getColors,
    getCompanyInfo,
    getAppConfig,
    getTypography,
    getCSSCustomProperties,
    getBrandedStyles,
    getSidebarLogo
} from '../utils/brandingUtils';

/**
 * Hook to get branded images for the current patron
 */
export const useBrandedImages = () => {
    return useMemo(() => ({
        ...getImages(),
        getSidebarLogo
    }), []);
};

/**
 * Hook to get branded colors for the current patron
 */
export const useBrandedColors = () => {
    return useMemo(() => getColors(), []);
};

/**
 * Hook to get company branding information
 */
export const useCompanyBranding = () => {
    return useMemo(() => getCompanyInfo(), []);
};

/**
 * Hook to get app-specific branding configuration
 */
export const useAppBranding = () => {
    return useMemo(() => getAppConfig(), []);
};

/**
 * Hook to get typography branding configuration
 */
export const useTypographyBranding = () => {
    return useMemo(() => getTypography(), []);
};

/**
 * Hook to get CSS custom properties for the current brand
 */
export const useBrandedCSSProperties = () => {
    return useMemo(() => getCSSCustomProperties(), []);
};

/**
 * Hook to get styled components for branded elements
 * @param {string} type - Component type (button, background, text)
 * @param {string} variant - Component variant (primary, secondary, etc.)
 */
export const useBrandedStyles = (type, variant = 'primary') => {
    return useMemo(() => getBrandedStyles(type, variant), [type, variant]);
}; 